export default __webpack_public_path__ + "static/media/back_bcr.c0056c55.svg";